'use client';

import React from 'react';
import type {
    DialogTriggerProps as AriaDialogTriggerProps,
    MenuTriggerProps as AriaMenuTriggerProps,
} from 'react-aria-components';
import { DialogTrigger as AriaDialogTrigger, MenuTrigger as AriaMenuTrigger } from 'react-aria-components';

const ROMA_POPOVER_DIALOG_TRIGGER_DISPLAY_NAME = 'RomaPopoverDialogTrigger';
const ROMA_POPOVER_MENU_TRIGGER_DISPLAY_NAME = 'RomaPopoverMenuTrigger';

export type PopoverDialogTriggerProps = AriaDialogTriggerProps;
export type PopoverMenuTriggerProps = AriaMenuTriggerProps;

/**
 * Use `PopoverDialogTrigger` for non-menu popovers such as detail panels, forms, and other anchored overlays
 * that should follow dialog semantics instead of menu semantics.
 */
export const PopoverDialogTrigger: React.FC<PopoverDialogTriggerProps> = ({ children, ...props }) => (
    <AriaDialogTrigger {...props}>{children}</AriaDialogTrigger>
);

PopoverDialogTrigger.displayName = ROMA_POPOVER_DIALOG_TRIGGER_DISPLAY_NAME;

/**
 * Use `PopoverMenuTrigger` for menu-style popovers such as menus, context menus, and submenu overlays
 * that need menu keyboard semantics.
 */
export const PopoverMenuTrigger: React.FC<PopoverMenuTriggerProps> = ({ children, ...props }) => (
    <AriaMenuTrigger {...props}>{children}</AriaMenuTrigger>
);

PopoverMenuTrigger.displayName = ROMA_POPOVER_MENU_TRIGGER_DISPLAY_NAME;
